<template>
  <div class="slider-wrapper">
    <!-- Slides -->
    <div class="slider-content">
      <slot :current="currentIndex"/>
    </div>


    <!-- Controls -->
    <div v-if="indexes.length > 1" class="tw-text-center tw-mt-4">
      <base-icon
        icon="arrow-circle-right"
        size="20"
        @click="prev"
        :class="hasPrev && '!tw-text-blue-500 tw-cursor-pointer'"
        class="tw-inline-block tw-p-2 tw-text-blue-dark-100"
      />

      <span class="tw-mx-2 tw-inline-block tw-align-super">
        {{ indexes.indexOf(currentIndex)+1 }} از {{ indexes.length }}
      </span>

      <base-icon
        icon="arrow-circle-left"
        size="20"
        @click="next"
        :class="hasNext && '!tw-text-blue-500 tw-cursor-pointer'"
        class="tw-inline-block tw-p-2 tw-text-blue-dark-100"
      />
    </div>
  </div>
</template>

<script setup>
import {computed, ref, defineProps, onMounted} from 'vue'
import BaseIcon from '@/components/base/BaseIcon.vue'

const props = defineProps({
  indexes: {
    type: Array,
    default: []
  }
})
const currentIndex = ref()

onMounted(() => {
  currentIndex.value = props.indexes[0]
})

const hasNext = computed(() => props.indexes.indexOf(currentIndex.value) < props.indexes.length - 1)
const hasPrev = computed(() => props.indexes.indexOf(currentIndex.value) > 0)

const next = () => {
  if (hasNext.value) {
    let ci = props.indexes.indexOf(currentIndex.value)
    currentIndex.value = props.indexes[ci + 1]
  }
}

const prev = () => {
  if (hasPrev.value) {
    let ci = props.indexes.indexOf(currentIndex.value)
    currentIndex.value = props.indexes[ci - 1]
  }
}
</script>
